module.exports = __webpack_public_path__ + "img/public_filetype_pdf_normal.1e0ac587.svg";